import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '@env/environment';
import {OfferingTypesResponse, UpdateOfferingTypesRequest} from './offering-types.model';

/**
 * FE-20 — location offering-types admin endpoints (BE-14, tech spec §4.16 / §8.2-22).
 */
@Injectable({providedIn: 'root'})
export class OfferingTypesService {
  constructor(private http: HttpClient) {}

  getOfferingTypes(locationUuid: string): Observable<OfferingTypesResponse> {
    return this.http.get<OfferingTypesResponse>(`${this.baseUrl}/locations/${locationUuid}/offering-types`);
  }

  putOfferingTypes(locationUuid: string, enabledTypeCodes: string[]): Observable<OfferingTypesResponse> {
    const req: UpdateOfferingTypesRequest = {enabledTypeCodes};
    return this.http.put<OfferingTypesResponse>(`${this.baseUrl}/locations/${locationUuid}/offering-types`, req);
  }

  private get baseUrl(): string {
    return environment.apiLandlordHost + '/admin';
  }
}
